import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { EntityActions } from 'common/entity';
import { Chapter } from 'common/api/models/Chapter';
import { Table } from 'reactstrap';
import { Loading } from 'common/components/Loading';
import { toApiError } from 'common/utils/api';
import { ChapterPosition } from 'common/api/models/ChapterPosition';

export interface ChaptersDetailMembersProps {
  chapter: Chapter;
  members: ChapterPosition[];
  appState: AppState;
  entityActions: EntityActions;
}

export interface ChaptersDetailMembersState {
  isLoading: boolean;
  members: ChapterPosition[];
  error?: string;
}

export class ChaptersDetailMembers extends React.Component<ChaptersDetailMembersProps, ChaptersDetailMembersState> {
  state: ChaptersDetailMembersState = {
    isLoading: false,
    members: [],
  };

  handleError = (err: Error) => this.setState({ error: toApiError(err), isLoading: false });

  render() {
    const members = this.props.members!;

    console.log('Test: ' + members);

    return (
      <Table responsive={true} hover={true} striped={true}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Last Login</th>
          </tr>
        </thead>
        <tbody>
          {!this.state.isLoading &&
            !this.state.error &&
            this.props.members &&
            this.props.members.length === 0 && (
              <tr>
                <td colSpan={4}>No results found.</td>
              </tr>
            )}
          {this.state.error && (
            <tr>
              <td colSpan={3}>
                <div className="alert alert-danger">{this.state.error}</div>
              </td>
            </tr>
          )}
          {members &&
            members!.map(function(chapterPosition: ChapterPosition) {
              return (
                <tr key={chapterPosition.id}>
                  <td>
                    {chapterPosition.member!.lastName}, {chapterPosition.member!.firstName}
                  </td>
                  <td>{chapterPosition.positionName}</td>
                  <td>{chapterPosition.member!.workPhone}</td>
                  <td>{chapterPosition.member!.email}</td>
                  <td>{chapterPosition.member!.loginAt}</td>
                </tr>
              );
            })}
          {this.state.isLoading && (
            <tr>
              <td colSpan={4}>
                <Loading />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Chapters/ChaptersDetailMembers.tsx